import { StepperStep as MantineStepperStep } from '@mantine/core'

import { StepperStepProps } from './stepper-step.types'

export const StepperStep = ({ ...props }: StepperStepProps) => (
  <MantineStepperStep {...props} />
)
